import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import { router } from "./router";
import { StrictMode } from "react";
import { PostHogProvider } from "posthog-js/react";
import { loadChurch } from "./core/church/church";

// Titles, logos and copy read the church as they render, so it's known before the first one
loadChurch().then(() =>
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ReactDOM.createRoot(document.getElementById("root")!).render(
        <StrictMode>
            <PostHogProvider
                apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
                options={{
                    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
                    capture_pageview: "history_change",
                    capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
                    debug: import.meta.env.MODE === "development",
                }}
            >
                <RouterProvider router={router} />
            </PostHogProvider>
        </StrictMode>
    )
);
